import React, { useState, useMemo } from 'react';

const PAGE_SIZE = 50;

function formatDate(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function DrawHistoryTab({ game, draws, freq, getBallClass }) {
  const [page, setPage] = useState(0);

  const reversed = useMemo(() => [...draws].reverse(), [draws]);
  const totalPages = Math.ceil(reversed.length / PAGE_SIZE);
  const pageDraws = reversed.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <>
      <div className="history-legend">
        <span className="history-legend-item"><span className="history-legend-dot hot" />Hot — top 20% most drawn</span>
        <span className="history-legend-item"><span className="history-legend-dot warm" />Warm — top 40%</span>
        <span className="history-legend-item"><span className="history-legend-dot neutral" />Neutral</span>
        <span className="history-legend-item"><span className="history-legend-dot cold" />Cold — bottom 20%</span>
      </div>
      <p className="section-label">
        Draw results ({reversed.length} total) — Page {page + 1} of {totalPages}
      </p>
      <div className="history-table-wrap">
        <table className="gap-table history-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Numbers</th>
              <th>{game.bonusName}</th>
              {game.id === 'powerball' && <th>Multi</th>}
            </tr>
          </thead>
          <tbody>
            {pageDraws.map((draw, i) => (
              <tr key={i}>
                <td className="history-date">{formatDate(draw.date)}</td>
                <td>
                  <div className="history-balls">
                    {draw.main.map((n, j) => (
                      <div className={`history-ball ${getBallClass(freq[n] || 0)}`} key={j}>{n}</div>
                    ))}
                  </div>
                </td>
                <td>
                  {draw.bonus && (
                    <div
                      className="history-ball history-bonus"
                      style={{
                        background: `${game.bonusColor}22`,
                        borderColor: game.bonusColor,
                        color: game.bonusColor,
                      }}
                    >
                      {draw.bonus}
                    </div>
                  )}
                </td>
                {game.id === 'powerball' && (
                  <td className="history-multi">{draw.multiplier || '—'}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="history-pagination">
          <button
            className="mode-btn"
            disabled={page === 0}
            onClick={() => setPage(p => p - 1)}
          >
            ← Prev
          </button>
          <span className="history-page-info">
            {page + 1} / {totalPages}
          </span>
          <button
            className="mode-btn"
            disabled={page >= totalPages - 1}
            onClick={() => setPage(p => p + 1)}
          >
            Next →
          </button>
        </div>
      )}
    </>
  );
}
